import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Text = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
  padding: 0 0 10px 0;

  a {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px 10px 5px 10px;
  }
`;
